export function checkNA<T>(value: T) {
  if (typeof value === 'string') {
    if (value === '') {
      return 'N/A';
    }
    return value;
  }
  return null;
}
